function cov_2oefn8tspw() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Filter.tsx";
  var hash = "f7bfe863e4955fb70bc779f1607ff6ae447a543d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Filter.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 46
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f7bfe863e4955fb70bc779f1607ff6ae447a543d"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2oefn8tspw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2oefn8tspw();
var Icon = (cov_2oefn8tspw().s[0]++, {
  name: 'filter',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.2499 6C21.193 6.68801 20.5873 7.24575 19.8969 7.24575H3.89694C3.20659 7.24575 2.69304 6.68801 2.74991 6C2.80677 5.31199 3.41252 4.75425 4.10287 4.75425L20.1029 4.75425C20.7932 4.75425 21.3068 5.31199 21.2499 6Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.7499 12C18.7499 12.6904 18.1903 13.25 17.4999 13.25L6.49991 13.25C5.80955 13.25 5.24991 12.6904 5.24991 12C5.24991 11.3096 5.80955 10.75 6.49991 10.75H17.4999C18.1903 10.75 18.7499 11.3096 18.7499 12Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.9499 18C15.9499 18.6904 15.3903 19.25 14.6999 19.25H8.69992C8.00956 19.25 7.44992 18.6904 7.44992 18C7.44992 17.3096 8.00956 16.75 8.69992 16.75H14.6999C15.3903 16.75 15.9499 17.3096 15.9499 18Z\" fill=\"currentColor\"/>"
});
export default Icon;